
import React from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

const TickerMarquee: React.FC = () => {
  const container = React.useRef<HTMLDivElement>(null);

  useGSAP(() => {
    gsap.to(".marquee-inner", {
      xPercent: -50,
      repeat: -1,
      duration: 30,
      ease: "linear"
    });
  }, { scope: container });

  return (
    <div ref={container} className="relative w-full py-4 md:py-8 bg-[#1A3C28] overflow-hidden whitespace-nowrap border-y border-white/5">
      <div className="marquee-inner flex font-display font-black uppercase text-[#F2E9D8] tracking-tighter items-center marquee-text">
        <div className="flex items-center gap-6 md:gap-12 px-4 md:px-8">
            <span>GUSTO</span>
            <span className="text-outline">CRAFTED</span>
            <span>GUSTO</span>
            <span className="text-[#E05A38]">STUDIO</span>
            <span>GUSTO</span>
            <span className="text-outline">FRESH</span>
        </div>
        <div className="flex items-center gap-6 md:gap-12 px-4 md:px-8">
            <span>GUSTO</span>
            <span className="text-outline">CRAFTED</span>
            <span>GUSTO</span>
            <span className="text-[#E05A38]">STUDIO</span>
            <span>GUSTO</span>
            <span className="text-outline">FRESH</span>
        </div>
      </div>
    </div>
  );
};

export default TickerMarquee;
